// Implements DESIGN.md "Loading states" — skeletons match the shape of
// the content they replace; never bare "Loading…" text.
import { Card } from '@/components/ui/Card';
import { Skeleton } from '@/components/ui/Skeleton';

export function GanttSkeleton() {
  return (
    <div className="max-w-6xl space-y-5">
      <header className="flex items-end justify-between flex-wrap gap-3">
        <div className="space-y-2">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-8 w-24" />
          <Skeleton className="h-4 w-full max-w-md" />
        </div>
        <Skeleton className="h-8 w-48 rounded-[var(--radius)]" />
      </header>
      <Card>
        <div className="space-y-3">
          <Skeleton className="h-5 w-1/3" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      </Card>
    </div>
  );
}
